/// <reference path="../types.d.ts" />
import { createReducer } from '@reduxjs/toolkit';
import InitialState from '../reducers/initial-state';
import * as CapturedTimeActions from '../actions/captured-time';
import { LOAD_STATES } from './common';
import { logout } from '../actions/ui';
import { jumpContext } from '../actions/contexts.action';
const reducer = createReducer(InitialState.capturedTime, (builder)=>{
    builder.addCase(logout.type, ()=>({
            ...InitialState.capturedTime
        }));
    builder.addCase(jumpContext.pending.type, ()=>({
            ...InitialState.capturedTime
        }));
    builder.addCase(CapturedTimeActions.toggleIsOpenCapturedTime, (state, action)=>({
            ...state,
            capturedTimeIsOpen: action.payload
        }));
    builder.addCase(CapturedTimeActions.listCapturedTimeForWeek.pending, (state)=>({
            ...state,
            loadState: LOAD_STATES.started,
            addTimeFailed: false
        }));
    builder.addCase(CapturedTimeActions.listCapturedTimeForWeek.rejected, (state)=>({
            ...state,
            loadState: LOAD_STATES.failed
        }));
    builder.addCase(CapturedTimeActions.listCapturedTimeForWeek.fulfilled, (state, action)=>{
        let newCapturedTimeWeek;
        let newNoPastCapturedTimeFlag = state.noPastCapturedTimeFlag;
        if (action.payload.content.length === 0) {
            newCapturedTimeWeek = state.capturedTimeWeek;
            newNoPastCapturedTimeFlag = true;
        } else {
            newCapturedTimeWeek = action.payload.content;
            newNoPastCapturedTimeFlag = false;
        }
        return {
            ...state,
            capturedTimeWeek: newCapturedTimeWeek,
            loadState: LOAD_STATES.done,
            noPastCapturedTimeFlag: newNoPastCapturedTimeFlag
        };
    });
    builder.addCase(CapturedTimeActions.listProtectedTimeForWeek.pending, (state)=>({
            ...state,
            loadState: LOAD_STATES.started
        }));
    builder.addCase(CapturedTimeActions.listProtectedTimeForWeek.rejected, (state)=>({
            ...state,
            loadState: LOAD_STATES.failed
        }));
    builder.addCase(CapturedTimeActions.listProtectedTimeForWeek.fulfilled, (state, action)=>{
        const newProtectedTimeWeek = state.noPastCapturedTimeFlag ? state.protectedTimeWeek : action.payload.content;
        return {
            ...state,
            protectedTimeWeek: newProtectedTimeWeek,
            loadState: LOAD_STATES.done,
            needRefreshFlag: false
        };
    });
    builder.addCase(CapturedTimeActions.deleteProtectedTimeEntry.pending, (state)=>({
            ...state,
            loadState: LOAD_STATES.started
        }));
    builder.addCase(CapturedTimeActions.deleteProtectedTimeEntry.rejected, (state)=>({
            ...state,
            loadState: LOAD_STATES.failed
        }));
    builder.addCase(CapturedTimeActions.deleteProtectedTimeEntry.fulfilled, (state)=>({
            ...state,
            loadState: LOAD_STATES.done,
            needRefreshFlag: true
        }));
    builder.addCase(CapturedTimeActions.updateProtectedTimeEntry.pending, (state)=>({
            ...state,
            loadState: LOAD_STATES.started
        }));
    builder.addCase(CapturedTimeActions.updateProtectedTimeEntry.rejected, (state)=>({
            ...state,
            loadState: LOAD_STATES.failed
        }));
    builder.addCase(CapturedTimeActions.updateProtectedTimeEntry.fulfilled, (state)=>({
            ...state,
            loadState: LOAD_STATES.done,
            needRefreshFlag: true
        }));
    builder.addCase(CapturedTimeActions.addProtectedTimeEntry.pending, (state)=>({
            ...state,
            loadState: LOAD_STATES.started,
            addTimeFailed: false
        }));
    builder.addCase(CapturedTimeActions.addProtectedTimeEntry.rejected, (state)=>({
            ...state,
            addTimeFailed: true,
            loadState: LOAD_STATES.failed
        }));
    builder.addCase(CapturedTimeActions.addProtectedTimeEntry.fulfilled, (state)=>({
            ...state,
            loadState: LOAD_STATES.done,
            needRefreshFlag: true,
            addTimeFailed: false
        }));
    builder.addCase(CapturedTimeActions.getMaxAllowedBackdate.pending, (state)=>({
            ...state,
            loadState: LOAD_STATES.started
        }));
    builder.addCase(CapturedTimeActions.getMaxAllowedBackdate.rejected, (state)=>({
            ...state,
            loadState: LOAD_STATES.failed
        }));
    builder.addCase(CapturedTimeActions.getMaxAllowedBackdate.fulfilled, (state, action)=>({
            ...state,
            loadState: LOAD_STATES.done,
            maxAllowedBackdate: action.payload[0].value
        }));
});
export default reducer;
